import { useUIStore } from "@/stores/useUIStore";

const CHUNK_RELOAD_KEY = "wexare:chunk-reload-attempted";

let recoveryInFlight = false;

function safeSession(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function readFlag(): boolean {
  try {
    return safeSession()?.getItem(CHUNK_RELOAD_KEY) === "1";
  } catch {
    return false;
  }
}

export function didRecoverFromChunkError(): boolean {
  return readFlag();
}

export function isChunkReloadInFlight(): boolean {
  return recoveryInFlight;
}

export function installChunkReloadHandler(): void {
  // Clear the flag once the recovered page successfully loads, so a *later*
  // deploy in the same tab can also trigger a recovery.
  window.addEventListener("load", () => {
    try {
      safeSession()?.removeItem(CHUNK_RELOAD_KEY);
    } catch {
      /* sessionStorage unavailable; flag will linger this tab — acceptable */
    }
  });

  window.addEventListener("vite:preloadError", (event) => {
    if (readFlag()) {
      // Recovery already attempted this pageload — surface a visible banner
      // so the user knows to manually refresh, and let the underlying error
      // propagate so Sentry sees the failed-recovery case. Clear the in-flight
      // flag so sentry.ts's beforeSend filter does NOT suppress this error.
      recoveryInFlight = false;
      useUIStore.getState().markChunkRecoveryFailed();
      return;
    }

    event.preventDefault();
    recoveryInFlight = true;
    try {
      safeSession()?.setItem(CHUNK_RELOAD_KEY, "1");
    } catch {
      /* if we can't persist the flag we'll just retry on the next failure */
    }
    window.location.reload();
  });
}
